import React, { Component } from 'react';
import _ from 'lodash';
import Slider from 'react-slick';
import FontAwesome from 'react-fontawesome';
import shared from '../../utils/shared.js'
import { connect } from 'react-redux';

class Stories extends Component {

    constructor(props) {
        super(props);
        let dimensions = null;
        let pWidth;
        if (this.props.screen.orientation === "horizontal") {
            pWidth = this.props.screen.screenHeight / 3;
            dimensions = {
                padWidth: pWidth,
                slideWidth: pWidth * 0.90,
                sliderWidth: pWidth * 2 * 1.25,
                bdist: this.props.screen.r16_9.p10 * 0.6
            };
        }
        this.state = {
            stories: [],
            selectedCategoryId: null,
            groupCycle: 0,
            mouseX: 0,
            mouseY: 0,
            dim: dimensions,
            module: this.props.module,
            categories: [],
        };
        this.goToSlide = this.goToSlide.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.lastSlide = this.lastSlide.bind(this);
        this.prepareCycleButtons = this.prepareCycleButtons.bind(this);
        this.refDict = {};
        this.handleCategorySwitch = this.handleCategorySwitch.bind(this);
        this.prepareStoryCategories = this.prepareStoryCategories.bind(this);
        this.handleStoryNavDown = this.handleStoryNavDown.bind(this);
        this.handleStoryNavUp = this.handleStoryNavUp.bind(this);
    }

    componentWillMount(){
        shared.checkData(this.props.module);
    }

    componentDidMount() {
        //let date1 = new Date();
        this.populateStories(null);
        //let date2 = new Date();
        //let diff = date2.getTime()-date1.getTime();
    }

    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {

    }

    shouldComponentUpdate(prevProps, prevState) {
        if (shared.shallowEqual(this.state, prevState)) {
            return false;
        }
        return true;
    }

    goToSlide(slide) {
        this.refDict[0].slickGoTo(slide);
    }

    nextSlide() {
        this.refDict[0].slickNext();
    }

    lastSlide() {
        this.refDict[0].slickPrev();
    }

    slideChanged(slide) {
        this.setState({
            groupCycle: Math.floor(slide / 3)
        });
    }

    handleStoryNavDown(e) {
        if (e.preventDefault) e.preventDefault();
        this.setState({
            mouseX: e.nativeEvent.clientX,
            mouseY: e.nativeEvent.clientY,
        });
    }


    handleStoryNavUp(e, index) {
        var deltaX = Math.abs(e.nativeEvent.clientX - this.state.mouseX);
        var deltaY = Math.abs(e.nativeEvent.clientY - this.state.mouseY);
        var total = deltaX + deltaY;

        if (total < this.props.screen.r16_9.p10*0.5) { //adjust for swipe vs click/tap
            //console.log("navigating from stories: ", index);
            //console.log("navigating to: ", index);
            this.props.navroute(null, "Story", "Stories", {storyIndex: index})
            //this.props.switchDisplayModule({ id: this.props.displayData.selectedModuleId, story: Number(story_id), prevModule: this.props.displayData.selectedModuleId, navtype: "stories", selectedModuleType: "Story", prevModuleType: this.props.displayData.selectedModuleType }); //module id story lastmodule
            //this.props.navroute(this.props.displayData.selectedModuleId, Number(story_id), "Story", false)
        }
    }

    prepareModule(story, i) {
        if (Number(story.id) === -1) {
            return (
                <div className="phand" style={{ display: 'inline-block', width: this.state.dim.padWidth, height: this.state.dim.padWidth, padding: 0 }}>
                    <div id={story.id} style={{ fontSize: this.props.screen.r16_9.p10 * 0.2625, display: 'inline-block', marginTop: this.state.dim.slideWidth * .05, width: this.state.dim.slideWidth, height: this.state.dim.slideWidth }}>
                        <div style={{ width: this.state.dim.slideWidth, height: '100%' }} className="aligner">
                            <div style={{ width: this.state.dim.slideWidth, backgroundColor: 'rgba(0,0,0,0)', padding: this.props.screen.r16_9.p10 * .15 }} className="aligner-item--bottom">
                                <b>&nbsp;</b>
                            </div>
                        </div>
                    </div>
                </div>
                // <span style={{ display: 'inline-block', width: this.state.dim.padWidth, height: this.state.dim.padWidth, padding: 0 }}>
                //     <span style={{ display: 'inline-block', width: this.state.dim.slideWidth, height: this.state.dim.slideWidth }}>&nbsp;</span>
                // </span>
            )
        }
        else {
            return (
                <div className="phand" style={{ display: 'inline-block', width: this.state.dim.padWidth, height: this.state.dim.padWidth, padding: 0 }}>
                    <div id={story.id} onMouseDown={this.handleStoryNavDown} onMouseUp={(e) => this.handleStoryNavUp(e, story.index)} style={{ fontSize: this.props.screen.r16_9.p10 * .2625, display: 'inline-block', marginTop: this.state.dim.slideWidth * .05, width: this.state.dim.slideWidth, height: this.state.dim.slideWidth, backgroundImage: story.iconPath, backgroundSize: 'cover' }}>
                        <div style={{ width: this.state.dim.slideWidth, height: '100%' }} className="aligner">
                            <div style={{ width: this.state.dim.slideWidth, backgroundColor: 'rgba(0,0,0,.5)', padding: this.props.screen.r16_9.p10 * .15 }} className="aligner-item--bottom">
                                <b>{story.name}</b>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    populateStories = (selected_category) => {
        let stories = [];
        let filterByCategory = false;

        if (this.props.categories.length > 0) {
            if (selected_category != null) {
                filterByCategory = true;
            }
        }
        _.forEach(this.props.module.stories, (story, index) => {
            if (filterByCategory === false || (selected_category === Number(story.folder))) { //|| (this.state && Number(this.state.selectedCategoryId)==Number(story.story_category))
                let preparedStory = story;
                preparedStory.index = index;       
                preparedStory.iconPath = "url(img/ui/image_default.png?rev="+this.props.screen.timeStamp+")"
                if (_.has(story, "contents.images[0].path")){
                    preparedStory.iconPath = "url(" + shared.dpath(this.props.screen.mode, story.contents.images[0].path, story.contents.images[0].file_name, this.props.screen.webkey) + ")";
                    // preparedStory.iconPath = "url(" + this.props.screen.dpath + story.contents.images[0].path + story.contents.images[0].file_name + ")";
                }              
                //console.log(preparedStory.iconPath);  
                stories.push(preparedStory);
            }
        });
        if (stories.length < 6) {
            while (stories.length < 6) {
                stories.push({ id: -1 }); //fill for blank spaces
            }
        }

        while (stories.length % 2 !== 0) {
            stories.push({ id: -1 }); //ensure even slide count
        }

        this.setState({
            stories: stories
        })

        if (this.state.categories.length===0){ //only run once
           let cats = [];

            _.forEach(this.props.categories, (cat) => {
                if (_.find(stories, {folder: cat.id})){
                    cats.push(cat);
                }
            })

            this.setState({
                categories: cats
            })         
        }

    }

    prepareModules = () => {

        if (this.state.stories.length === 0) {
            return <div />
        }

        if (this.props.screen.orientation === "horizontal") { //horizontal mode

            if (this.state.stories.length === 0) {
                return (<div>No Stories Found</div>)
            }

            //code to map an array of evens instead of all to fix console error.
            let evenRefIds = [];
            for (var i = 0; i < this.state.stories.length; i++) {
                if (i % 2 === 0) {
                    evenRefIds.push({ value: i });
                }
            }

            return (
                evenRefIds.map(function (row, i) {

                    return (
                        <div key={i} >
                            {this.prepareModule(this.state.stories[row.value], row.value)}
                            {this.prepareModule(this.state.stories[row.value + 1], row.value + 1)}
                        </div>
                    )

                }, this)
            )
        }
        else { //vertical mode
            return (
                <span />
            )
        }

    }

    prepareStoryCategories() {

        //console.log("CATEGORIES", this.props.categories);

        return (
            this.state.categories.map(function (row, i) {
                let classes = "phand cScale";
                let sty = { left: this.props.screen.r16_9.left, textAlign: 'left', fontSize: this.props.screen.r16_9.p10 * .325 }
                if (i === 0 && this.state.selectedCategoryId === null) {
                    //classes += " active";
                    sty = { left: this.props.screen.r16_9.left, textAlign: 'left', fontSize: this.props.screen.r16_9.p10 * 0.5 }
                }
                else if (Number(this.state.selectedCategoryId) === Number(row.id)) {
                    //classes += " active";
                    sty = { left: this.props.screen.r16_9.left, textAlign: 'left', fontSize: this.props.screen.r16_9.p10 * 0.5 }
                }
                return (
                    <div id={row.id} style={sty} onMouseDown={this.handleCategorySwitch} className={classes} key={i}>{row.name}</div>
                )
            }, this)
        )
    }

    prepareCycleButtons() {

        let iconStyle = { fontSize: this.props.screen.screenHeight*.05, color: 'rgba(255,255,255, .25' }
        let iconStyleActive = { fontSize: this.props.screen.screenHeight*.05, color: 'rgba(255,255,255, .75' }

        let spanclass = "phand fadediv"
        // return (<div style={{position:'absolute', left: blockWidth/2}}>HI THERE</div>)
        if (this.props.screen.idle===true){
            spanclass += " fadeout"
        }

        let divBlocks = []
        for (var i = 0; i < this.state.stories.length; i++) {
            if (i % 6 === 0) {
                divBlocks.push({ slide: i / 2 });
            }
        }

        if (divBlocks.length <= 1) {
            return <div />
        }

        return (
            divBlocks.map((row, i) => {
                let iStyle = iconStyle;
                if (i === this.state.groupCycle) {
                    iStyle = iconStyleActive;
                }
                if (i === 0) {
                    return (
                        <span className={spanclass} key={i}>
                            <div onMouseDown={() => this.lastSlide()} style={{ textAlign: 'center', position: 'inline-block', top: (-1 * this.state.dim.bdist) }}>
                                <span className={spanclass} style={iconStyle}><FontAwesome name='arrow-circle-up' /></span>
                            </div>
                            <div onMouseDown={() => this.goToSlide(row.slide)} style={{ textAlign: 'center', position: 'inline-block', top: (i * this.state.dim.bdist) }}>
                                <span className={spanclass} style={iStyle}><FontAwesome name='circle' /></span>
                            </div>
                        </span>
                    )
                }
                else if (i === divBlocks.length - 1) {
                    return (
                        <span className={spanclass} key={i}>
                            <div onMouseDown={() => this.goToSlide(row.slide)} style={{ textAlign: 'center', position: 'inline-block', top: (i * this.state.dim.bdist) }}>
                                <span className={spanclass} style={iStyle}><FontAwesome name='circle' /></span>
                            </div>
                            <div onMouseDown={() => this.nextSlide()} style={{ textAlign: 'center', position: 'inline-block', top: ((i + 1) * this.state.dim.bdist) }}>
                                <span className={spanclass} style={iconStyle}><FontAwesome name='arrow-circle-down' /></span>
                            </div>
                        </span>
                    )
                }
                else {
                    return (
                        <div className={spanclass} onMouseDown={() => this.goToSlide(row.slide)} key={i} style={{ textAlign: 'center', position: 'inline-block', top: (i * this.state.dim.bdist) }}>
                            <span className={spanclass} style={iStyle}><FontAwesome name='circle' /></span>
                        </div>
                    )
                }
            })
        )

    }

    handleCategorySwitch(e) {
        if (Number(e.target.id)!==Number(this.state.selectedCategoryId)){
            this.setState({
                selectedCategoryId: e.target.id
            })
            this.populateStories(Number(e.target.id));
        }
    }

    render() {

        if (!this.props.module){
            return(
                <span>Loading...</span>
            )
        }
        var settings = {
            dots: false,
            infinite: true,
            speed: 250,
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            swipeToSlide: false,
            arrows: false,
            afterChange: (currentSlide) => {
                this.slideChanged(currentSlide);
            },
        }
        if (this.props.screen.orientation === "horizontal") { //horizontal mode
            settings.vertical = true
            settings.verticalSwiping = true
        }

        let storyCategories = this.prepareStoryCategories();
        let modules = this.prepareModules();

        if (this.state.stories.length === 0) {
            return <div />
        }

        let sliderButtons = this.prepareCycleButtons();

        return (
            <div style={{ left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: '100vh', position: 'absolute' }}>
                <div id="content">
                    <div id="left" style={{ float: 'left', width: '65%', height: '100vh' }}>
                        <div style={{ position: 'absolute', left: this.props.screen.r16_9.p10*3}}>
                        <div style={{ position: 'absolute', height: this.props.screen.screenHeight, width: this.state.dim.sliderWidth, textAlign: 'center' }}>
                            <Slider ref={el => this.refDict[0] = el} {...settings}>
                                {modules}
                            </Slider>
                        </div>
                        <div style={{ height: this.props.screen.screenHeight, position: 'absolute' }}>
                            <div style={{ height: '100%' }} className="aligner">
                                <div className="aligner-item">
                                    {sliderButtons}
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div id="right" style={{ float: 'right', width: '35%', height: '100vh' }}>
                        <div style={{ lineHeight: '2', fontSize: this.props.screen.r16_9.p10 * .6 }} className="velem helem">
                            {storyCategories}
                        </div>
                    </div>
                    <br style={{ clear: 'both' }} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        screen: state.screen,
        module: state.content.dm_active[state.active_module],
        categories: state.content.story_categories
    };
};

export default connect(mapStateToProps, null)(Stories);


// WEBPACK FOOTER //
// ./src/Components/Story/Stories.js